import { render, staticRenderFns } from "./DashboardJournalPartenaires.vue?vue&type=template&id=76b25fca&scoped=true&"
import script from "./DashboardJournalPartenaires.vue?vue&type=script&lang=js&"
export * from "./DashboardJournalPartenaires.vue?vue&type=script&lang=js&"
import style0 from "./DashboardJournalPartenaires.vue?vue&type=style&index=0&id=76b25fca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b25fca",
  null
  
)

export default component.exports